const initialState = {
    responseFinancingDiscountList: {},
    responseFinancingDiscountDetail: null,
    responseCreate: null,
    responseUpdate: null,
    loading: false,
    error: null,
};

export default function financingDiscountReducer(state = initialState, action) {
    switch (action.type) {

        // LISTADO

        case 'FINANCING_DISCOUNT_LIST_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'FINANCING_DISCOUNT_LIST_RESPONSE':
            return {
                ...state,
                loading: false,
                responseFinancingDiscountList: action.value,
            };

        case 'FINANCING_DISCOUNT_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        // DETALLE

        case 'FINANCING_DISCOUNT_DETAIL_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'FINANCING_DISCOUNT_DETAIL_RESPONSE':
            return {
                ...state,
                loading: false,
                responseFinancingDiscountDetail: action.value,
            };

        // CREATE

        case 'FINANCING_DISCOUNT_CREATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseCreate: null,
            };

        case 'FINANCING_DISCOUNT_CREATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseCreate: action.value,
            };

        case 'FINANCING_DISCOUNT_CREATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        // UPDATE

        case 'FINANCING_DISCOUNT_UPDATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseUpdate: null,
            };

        case 'FINANCING_DISCOUNT_UPDATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseUpdate: action.value,
            };

        case 'FINANCING_DISCOUNT_UPDATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case 'FINANCING_DISCOUNT_CLEAR_STATE':
            return {
                ...state,
                error: null,
                responseCreate: null,
                responseUpdate: null,
            };

        default:
            return state;
    }
}
